export interface DomAnimatePlayer {
  cancel(): void;
  play(): void;
  pause(): void;
  finish(): void;
  onfinish: Function;
  position: number;
  currentTime: number;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
